import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { InstanceService } from '@tylertech/cj-inmate-search-angular-sdk';
import { ErrorPageService } from '../modules/shared/services/error-page.service';
import { getStateFromLoadError } from '../modules/shared/utils/error.utils';

@Injectable({
  providedIn: 'root'
})
export class InstanceExistsGuard {
  constructor(
    private readonly _instanceService: InstanceService,
    private readonly _errorPageService: ErrorPageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const alias = route.paramMap.get('alias');

    if (!alias) {
      this._errorPageService.showErrorPage(ErrorPageService.NotFound);
      return of(false);
    }

    return this._instanceService.instanceLookup({ alias }).pipe(
      map(config => {
        if (!config) {
          this._errorPageService.showErrorPage(ErrorPageService.NotFound);
          return false;
        }
        return true;
      }),
      catchError(error => {
        console.error('Error looking up instance:');
        const state = getStateFromLoadError(error);
        this._errorPageService.showErrorPage(state);
        return of(false);
      })
    );
  }
}